import clientNotifications from './clientNotifications';

export default clientNotifications;
